import React from 'react';
import sortUp from '../../../images/sort-up.svg';
import sortDown from '../../../images/sort-down.svg';
import sort from '../../../images/sort-solid.svg';

const TableHeader = ({listData, sortList, sortParam, allRows}) => {
    const sortImgByHeader = (param) => {
        const value = sortParam.find((e) => e.param === param);
        return value ? (value.ord === 'asc' ? sortUp : sortDown) : sort;
    };

    return (
        <thead>
            <tr className="il-lh-tr">
                { listData?.map( (item, i)=> {
                    return (
                    <td
                        key={i}
                        className="il-lh-td-empty"
                        style={item.allRows ? {width: item.width, textOverflow: 'ellipsis', whiteSpace: 'nowrap', paddingLeft: '4px'} : item.centerTitle ? {width: item.width, textAlign: 'center'} : {width: item.width, textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}
                        onClick={() => item.sort && sortList(item?.sortProp ? item?.sortProp : item?.att)}
                    >
                        {sortParam && item.sort &&
                            <img src={sortImgByHeader(item?.sortProp ? item?.sortProp : item?.att)} alt={'sort'} className="il-sort-btn"/>
                        }
                        {item?.title}
                        {allRows && item?.component && item.component() }
                    </td>
                    );
                } ) }
            </tr>
        </thead>
    );
};

/*
<td className="il-lh-td-lender il-lh-td-sortable"
                    onClick={() => console.log('sort') }
                >
    {'Nombre'}
    <img src={sortImgByHeader('name')} className="il-sort-btn"/>
</td>
<td className="il-lh-td-email" id='user.email' >{'Email'}</td>
<td className="il-lh-td-empty il-lh-td-sortable">{'Dato'}</td>
<td className="il-lh-td-empty"></td>
*/

export default TableHeader;
